(function () {
  "use strict";
  /* wg-card-wishlist.js - Wade Greens

     Puts a wishlist heart on the HOMEPAGE CAROUSEL cards.

     WHY IN JAVASCRIPT. Those cards are not product-card.liquid. They are the
     .epc__card markup inside sections/product-block.liquid, which is 72,893
     bytes - over the ~41,700-byte Admin API write ceiling proven on this
     store, so the file cannot be edited from here at all. Grepped 2026-10-02:
     that whole section contains the string "wishlist" exactly once, and only
     as the class name group-{{ settings.group_quickview_wishlist }}. There is
     no heart in it to turn on, which is why no theme setting ever produced one.

     WHAT IT BUILDS. The theme's own markup, not an invention:

       <div class="card-product__group-item card-wishlist">
         <button class="wishlist-icon show-mb wg-wl" data-wishlist
                 data-wishlist-handle="..." data-product-id="...">

     identical to snippets/product-card.liquid, so assets/component-card.css
     and assets/wg-card-wishlist.css style it with no extra work.

     WHO HANDLES THE CLICK. Halo's wishlist lives in assets/theme.js (186 KB)
     and binds its own hearts; a node injected after it booted is not
     guaranteed to be picked up. Rather than gamble on that, the injected
     buttons - and ONLY those, marked data-wg-wl - are handled here, writing
     the exact same store Halo reads: localStorage "wishlistItem", a JSON
     array of product handles. See the header of wg-wishlist-klaviyo.js, which
     documents that key and verified it live.

     ORDER OF LISTENERS, which matters:
       capture  wg-wishlist-klaviyo.js  account gate. Not signed in ->
                stopImmediatePropagation + redirect to login.
       bubble   this file               toggles the handle and the class.
       +250ms   wg-wishlist-klaviyo.js  diffs the list, fires the Klaviyo
                                        event and mirrors the profile.
     This file listens on the BUBBLE phase on purpose: when the gate stops the
     event, nothing here runs and nothing is saved for a signed-out visitor.

     Re-run safe. Every injection is guarded by data-wg-wl on the group, so
     carousel clones, AJAX filtering and shopify:section:load cannot double up.
  */

  var KEY = "wishlistItem";
  var MARK = "data-wg-wl";

  var HEART =
    '<svg class="icon icon-wishlist icon-heart-2" xmlns="http://www.w3.org/2000/svg"' +
    ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' +
    ' focusable="false" role="presentation">' +
    '<path d="M12 20.7 3.9 12.6a5.1 5.1 0 0 1 0-7.2 5.1 5.1 0 0 1 7.2 0l.9.9.9-.9a5.1 5.1 0 0 1 7.2 0 5.1 5.1 0 0 1 0 7.2Z"/>' +
    "</svg>";

  function readList() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  /* Handle and id are copied off the quick view button that already sits in
     the same group. If there is no quick view button, the handle is read from
     the card's own product link, which every .epc__card has. */
  function detailsFor(group, card) {
    var qv = group.querySelector("[data-product-handle]");
    if (qv) {
      return {
        handle: qv.getAttribute("data-product-handle") || "",
        id: qv.getAttribute("data-product-id") || ""
      };
    }
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return m ? { handle: m[1], id: "" } : null;
  }

  function buildButton(d, saved) {
    var item = document.createElement("div");
    item.className = "card-product__group-item card-wishlist";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "wishlist-icon show-mb wg-wl" + (saved ? " wishlist-added" : "");
    btn.setAttribute("data-wishlist", "");
    btn.setAttribute(MARK, "1");
    btn.setAttribute("data-wishlist-handle", d.handle);
    if (d.id) btn.setAttribute("data-product-id", d.id);
    btn.setAttribute("aria-pressed", saved ? "true" : "false");
    btn.setAttribute("title", "Add to Wishlist");
    btn.innerHTML = '<span class="text">Add to Wishlist</span>' + HEART;

    item.appendChild(btn);
    return item;
  }

  function inject() {
    var saved = readList();
    var groups = document.querySelectorAll(".epc__quickview");

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (group.hasAttribute(MARK)) continue;
      if (group.querySelector(".card-wishlist")) {
        group.setAttribute(MARK, "1");
        continue;
      }

      var card = group.closest(".epc__card");
      var d = detailsFor(group, card);
      if (!d || !d.handle) continue;

      group.insertBefore(
        buildButton(d, saved.indexOf(d.handle) !== -1),
        group.firstChild
      );
      group.setAttribute(MARK, "1");
    }
  }

  /* Keeps every injected heart agreeing with the stored list - after a save,
     after a removal on the wishlist page, and on first paint. */
  function sync() {
    var saved = readList();
    var btns = document.querySelectorAll("[" + MARK + "]");
    for (var i = 0; i < btns.length; i++) {
      var on = saved.indexOf(btns[i].getAttribute("data-wishlist-handle")) !== -1;
      btns[i].classList.toggle("wishlist-added", on);
      btns[i].setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[" + MARK + "]");
    if (!btn) return;

    e.preventDefault();

    var handle = btn.getAttribute("data-wishlist-handle");
    if (!handle) return;

    var list = readList();
    var at = list.indexOf(handle);
    if (at === -1) list.push(handle);
    else list.splice(at, 1);
    writeList(list);

    sync();
  });

  function boot() {
    inject();
    sync();

    /* The carousels clone and re-order slides, and collection filtering
       replaces whole grids, so watch instead of running once. */
    if ("MutationObserver" in window) {
      var pending = null;
      new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(function () {
          inject();
          sync();
        }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(function () {
        inject();
        sync();
      }, 60);
    });

    /* Another tab saved something. */
    window.addEventListener("storage", function (e) {
      if (!e.key || e.key === KEY) sync();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.wgCardWishlist = { inject: inject, sync: sync };
})();
